import { default as AnalysisResults, doubleEncodeInputs } from './AnalysisResults'
import { post } from 'tools/request'

class CustomResults extends AnalysisResults {
	fileName = 'custom'
	get analysisType() {
		return 'Custom' // TODO: This should be Custom
	}
	ready(properties) {
		if (!this.config.isUserTemplate.valueOf())	{
			this.inputs.options.package = 'metafor'
			this.initUserTemplate()
		}
		return super.ready(properties)
	}
	initUserTemplate() {
	}
	sendAnalysisRequest(isTemplated?: boolean) {
		return post('/portal/analysis/initializeData', {
			data: this.inputs/*Object.assign({
				varName: this.config.varName.valueOf(),
			}, this.inputs),*/
		})
	}
	startEditTemplate() {
		this.initUserTemplate()
	}
	get defaultPackage() {
		return ''
	}
	get canAddChildren() {
		return false//!this.isLocked && !this.hasParent
	}
	get hasDefaultTemplate() {
		return false
	}
	fetchRHeader() {
		return Promise.resolve('')
	}

}

export default CustomResults
